import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { BtnAdd, BtnBack, BtnDuplicate, BtnRemark, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import { AutoCompleteItem } from 'components/Input/AutoComplete';

const EquipmentWithdrawForm = () => {
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/EquipmentList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrEquipment, setEquipment] = useState<any>([]);
    const [arrUser, setarrUser] = useState<any>([]);
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [sRemark, setsRemark] = useState("");
    const [isDuplicate, SetDuplicate] = useState<boolean>(false);
    const [sOrder, setsOrder] = useState("");
    const [nReceiveType, setReceiveType] = useState(0);
    const [ReceiverID, setnReceiverID] = useState<any>([]);

    const sMode = new URLSearchParams(searchParams).get("sMode");
    const [nDupYear, setnDupYear] = useState(1);
    const [loadingTable, setLoadingTable] = useState(false);
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear() + 1, 0, 1);

    const dataColumn: any = [
        {
            field: "nOrder",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            width: 50,
            disableColumnMenu: true,
        },
        {
            field: "nEquipmentID",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        รายการ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                let arrClone = dataRow;
                let arrID = arrClone.arrRows.length > 0 ? arrClone.arrRows.filter(f => f.nEquipmentID != item.row.nEquipmentID).map((m) => m.nEquipmentID) : [];
                let arrData = arrEquipment.filter(f => !arrID.includes(f.value));
                return (
                    <FormProvider {...form}>
                        <SelectItem
                            id={`nEquipmentID_${item.row.sID}`}
                            name={`nEquipmentID_${item.row.sID}`}
                            placeholder={`${I18n.SetText("Material.sMaterial")}`}
                            options={arrData || []}
                            required={false}
                            disabled={!isPermission || sID != null}
                            IsShowMessageError={false}
                            onChange={(e) => {
                                //  getEquipment(e)
                                getEquipmentUnit(e ? e.sUnit : null, item.row.sID)
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "sUnit",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        หน่วยนับ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "sHolderName",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        ผู้ถือครอง
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        {nReceiveType == 2 &&
                            <TextBoxItem
                                required={true}
                                placeholder={"ผู้ถือครอง"}
                                id={`sHolderName_${item.row.sID}`}
                                name={`sHolderName_${item.row.sID}`}
                                maxLength={250}
                                type={'text'}
                                IsShowMessageError
                                disabled={!isPermission || sID != null}
                            />
                        }
                        {nReceiveType == 1 &&
                            <SelectItem
                                id={`nHolderID_${item.row.sID}`}
                                name={`nHolderID_${item.row.sID}`}
                                placeholder={"เลือกผู้ถือครอง"}
                                options={arrUser}
                                required={true}
                                disabled={!isPermission || sID != null}
                                IsShowMessageError={false}
                            />
                        }
                    </FormProvider>
                )
            }
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 80,

            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        <BtnRemark
                            id={"btn" + item.row.sID}
                            IsCircleWithOutText
                            className='btnicon-remark'
                            onClick={() => onOpenModal(item.row.sID, item.row.sRemark, item.row.sDetail)}
                        />

                    </>
                );

            },
        },

    ];

    const getFormInitial = () => {
        AxiosFn.Get(`Equipment/GetFormInitial`, {}, (result) => {
            setarrUser(result.lstUser);
        })
    }

    //ดึงข้อมูลรายการ
    const getEquipment = (e) => {
        let Param = {
            nWithdrawDate: form.getValues("dWithdraw") ? form.getValues("dWithdraw").valueOf() : null
        };
        AxiosFn.Post(`Equipment/GetEquipmentWithdraw`, Param, (result) => {
            setEquipment(result.lstEquipment);
        }, (err) => {
            DialogFn.UnBlockUI();
            if (!err.response) {
                DialogFn.Warning(err.sMessage);
            }
        });
    }

    //หาหน่วย
    const getEquipmentUnit = (sUnit, sID) => {

        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sUnit = f.sID == sID ? sUnit : f.sUnit;
            });
        }
        setDataRow({ ...arrClone });
    }
    //ผู้คุมครอง
    const setUser = (e) => {
        if (sID == null) {
            let arrClone = dataRow;
            if (arrClone.arrRows.length > 0) {
                arrClone.arrRows.forEach((f) => {
                    f.nHolderID = e;
                    form.setValue(`nHolderID_${f.sID}`, e);
                });
            }
            setDataRow({ ...arrClone });
        }
    }

    //บันทึกหมายเหตุ
    const onOpenModal = (sIDRow, sRemark, sDetail) => {
        setisOpen(true);
        setsOrder(sIDRow);
        form.setValue("sRemark", sRemark);
        setsRemark(form.getValues(`sRemark`));

    };
    const onSummitRemark = () => {
        setisOpen(false);
        let sRemarkform = form.getValues(`sRemark`);

        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sRemark = f.sID == sOrder ? sRemarkform : f.sRemark;
            });
        }
        setDataRow({ ...arrClone });
    }

    //Add TableItem
    const onSumitTable = (e) => {
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sID = f.sID;
                f.nOrder = f.nOrder;
                f.nEquipmentID = e[`nEquipmentID_${f.sID}`] ? e[`nEquipmentID_${f.sID}`] : f.nEquipmentID;
                f.nHolderID = e[`nHolderID_${f.sID}`] ? e[`nHolderID_${f.sID}`] : f.nHolderID;
                f.sHolderName = e[`sHolderName_${f.sID}`] ? e[`sHolderName_${f.sID}`] : f.sHolderName;
                f.sUnit = f.sUnit;
                f.sRemark = f.sRemark != "" ? f.sRemark : sRemark;
            });
        }

        let arrNewItem = [];
        let arrID =
            arrClone.arrRows.length > 0 ? arrClone.arrRows.map((m) => m.sID) : [];
        let nID = (arrID.length > 0 ? Math.max(...arrID) : 0) + 1;
        arrNewItem.push(...arrClone.arrRows);

        //Add New Item 
        let arrIDOnItem = arrNewItem.map((m) => m.nWithdrawItemID);
        let arrOrderOnItem = arrNewItem.map((m) => m.nOrder);
        let sID = arrNewItem.length > 0 ? Math.max(...arrIDOnItem) + 1 : nID;
        let nReceiverID = form.getValues("nReceiverID") ? form.getValues("nReceiverID").value : 0;

        let objNewItem: EquipmentWithdrawIItem = {};
        objNewItem.sID = sID + "";
        objNewItem.nOrder = arrNewItem.length > 0 ? Math.max(...arrOrderOnItem) + 1 : nID;
        objNewItem.nEquipmentID = 0;
        objNewItem.nWithdrawID = sID;
        objNewItem.nWithdrawItemID = sID;
        objNewItem.nHolderID = nReceiverID;
        arrNewItem.push(objNewItem);
        arrClone.arrRows = [...arrNewItem];
        setDataRow({ ...arrClone });
        form.setValue(`nHolderID_${sID}`, nReceiverID);

    };

    //ลบข้อมูลในตาราง
    const handleDelete = (arrID) => {
        DialogFn.Submit(`${I18n.SetText("Material.sConfirmDel")}`, () => {
            let arrClone = dataRow;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !arrID.includes(f.sID));

            // เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }
            setDataRow({
                ...arrClone,
                nDataLength: arrClone.arrRows.length,
            });
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });
    };

    // บันทึกเบิก
    const onSubmit = (e, sMode, nDupYear) => {
    
        let lstDataType = []
        let lstData = []
        lstData = dataRow.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                sID: item.sID,
                nOrder: item.nOrder,
                nEquipmentID: e[`nEquipmentID_${item.sID}`] ? e[`nEquipmentID_${item.sID}`] : item.nMaterialTypeID,
                nHolderID: e[`nHolderID_${item.sID}`] ? e[`nHolderID_${item.sID}`] : item.nHolderID,
                sHolderName: e[`sHolderName_${item.sID}`] ? e[`sHolderName_${item.sID}`] : item.sHolderName,
                sUnit: item.sUnit,
                sRemark: form.getValues("sRemark") ? form.getValues("sRemark") : item.sRemark,
            })
        })

        if (ReceiverID && sID) {
            form.setValue("nReceiverID", ReceiverID);
        }
        let param = {
            sID: sID ? sID : "",
            sDocumentNo: form.getValues("sDocumentNo"),
            nWithdrawDate: form.getValues("dWithdraw").valueOf(),
            nReceiverUnitType: +form.getValues("sReceiverUnitType"),
            nReceiverID: form.getValues("nReceiverID") ? form.getValues("nReceiverID").value : 0,
            sExternalReceiver: form.getValues("sExternalReceiver") ? form.getValues("sExternalReceiver") : null,
            lstDataWithdraw: lstDataType,
            nDupYear: nDupYear
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Equipment/SaveWithdrawEquipment`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate("/EquipmentList?sMode=" + sMode);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    //ดึงข้อมูลมาแก้ไข
    const getEquipmentEdit = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`Equipment/GetWithdrawEquipmentEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataWithdraw],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            if (sID) {
                setTimeout(() => {
                    (result.lstDataWithdraw ?? []).forEach(f => {
                        f.nOrder = f.nOrder;
                        form.setValue(`nEquipmentID_${f.sID}`, f.nEquipmentID);
                        form.setValue(`nHolderID_${f.sID}`, f.nHolderID);
                        form.setValue(`sHolderName_${f.sID}`, f.sHolderName);
                        form.setValue(`sRemark`, f.sRemark);
                    })
                }, 500);
                setEquipment(result.lstEquipment);
                setReceiveType(result.nReceiverUnitType);
                form.setValue(`sExternalReceiver`, result.sExternalReceiver);
                form.setValue(`nReceiverID`, result.objReceiverID);
                form.setValue("sReceiverUnitType", result.nReceiverUnitType + "");
                form.setValue("dWithdraw", moment(result.nWithdrawDate));
                form.setValue("sDocumentNo", result.sDocumentNo);
                setnReceiverID(result.objReceiverID);

            }

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    const onDuplicate = (e, nDup) => {

        let param = {
            lstDataRow: dataRow.arrRows,
            nDup: nDup
        }
        DialogFn.Submit("คุณต้องการคัดลอกไปปีถัดไป ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Equipment/GetWithdrawItem`, param, (result) => {
                DialogFn.UnBlockUI();
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstEquipmentWithdrawItem
                });
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                form.setValue("dWithdraw", null);
                form.setValue("nReceiverID", ReceiverID);
                setnDupYear(2);
                SetDuplicate(true);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (err.nStatusCode === 409) {
                    DialogFn.SubmitWarning(err.sMessage, () => {
                      //  setnDupYear(0);
                        onDuplicateNew(2);
                        DialogFn.CloseSubmitWarning()
                    })
                }
            });
        });
    }

    const onDuplicateNew = (nDup) => {
        form.setValue("dWithdraw", null);
        form.setValue("nReceiverID", ReceiverID);
        setnDupYear(2);
        let param = {
            lstDataRow: dataRow.arrRows,
            nDup: nDup
        }
        AxiosFn.Post(`Equipment/GetWithdrawItem`, param, (result) => {
            setDataRow({
                ...dataRow,
                arrRows: result.lstEquipmentWithdrawItem
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(`บันทึกสำเร็จ555`);
            DialogFn.CloseSubmit()
            SetDuplicate(true);
        }
        );
    }

    useEffect(() => {
        getEquipmentEdit(dataRow);
        getFormInitial();
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            maxDate={isDuplicate ? null : moment()}
                            minDate={isDuplicate ? _dStart : null}
                            // view={["month", "day"]}
                            required={true}
                            name={"dWithdraw"}
                            id={"dWithdraw"}
                            label={`${I18n.SetText("Equipment.sWithdrawDateForm")}`}
                            fullWidth
                            disabled={!isPermission || (nDupYear == 2 ? false : sID != null)}
                            defaultCalendarMonth={moment().startOf('year').year(moment(isDuplicate ? _dStart : null).year())}
                            onChange={(e) => {
                                getEquipment(e)
                            }}

                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Material.sDocOrderNo")}`}
                            id={'sDocumentNo'}
                            name={'sDocumentNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}></Grid>
                    <Grid item container xs={12} md={12}>
                        <Grid item container xs={12} md={3} sx={{ marginBottom: "10px" }} >

                            <RadioListItem
                                id={"sReceiverUnitType"}
                                name={"sReceiverUnitType"}
                                required={true}
                                options={[
                                    { value: "1", label: `${I18n.SetText("Material.sFossilManagement")}` },
                                    { value: "2", label: `${I18n.SetText("Material.sExternal")}` },
                                ]}
                                onChange={(e) => {
                                    setReceiveType(e ? e : null)
                                    form.setValue(`nReceiverID`, null);
                                }}

                                disabled={!isPermission || sID != null}
                                label={`${I18n.SetText("Material.sAgency")}`}
                            />

                        </Grid>

                        <Grid item container xs={12} md={6} sx={{ marginTop: "17px" }} >
                            <Grid item xs={12} md={8} >
                                {nReceiveType == 1 &&
                                    <AutoCompleteItem
                                        id={`nReceiverID`}
                                        name={`nReceiverID`}
                                        sUrlAPI={`MaterialInventory/GetSearchUser`}
                                        label={`${I18n.SetText("Equipment.sWithdrawReceiver")}`}
                                        placeholder={`${I18n.SetText("Equipment.sWithdrawReceiver")}`}
                                        required={nReceiveType == 1}
                                        disabled={!isPermission || sID != null}
                                        fullWidth
                                        onChange={(e) => {
                                            setUser(e ? e.value : null)
                                        }}
                                    />
                                }
                            </Grid>
                            <Grid item container xs={12} md={12} sx={{ marginTop: "17px" }} >
                                {nReceiveType == 2 &&
                                    <Grid item xs={12} md={12}>
                                        <TextBoxItem
                                            required={nReceiveType == 2}
                                            label={`${I18n.SetText("Material.sExternalReceiver")}`}
                                            id={'sExternalReceiver'}
                                            name={'sExternalReceiver'}
                                            maxLength={250}
                                            type={'text'}
                                            IsShowMessageError
                                            disabled={!isPermission || sID != null}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DataGrid
                            columns={dataColumn}
                            rows={dataRow}
                            isDisableColumnMenu={true}
                            onDelete={handleDelete}
                            isHiddenToolHead
                            isHiddenPagination
                            isShowCheckBox={isPermission || sID == null}
                            onRowSelectable={(p) => sID == null}
                            isLoading={loadingTable}

                        />
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Grid container justifyContent="flex-start" xs={12} md={12} spacing={2}>
                            {sID == null &&
                                <Grid item>
                                    <BtnAdd id={"btnSave"}
                                        txt='เพิ่มข้อมูล'
                                        IsDisabled={!isPermission}
                                        onClick={form.handleSubmit((e) => { onSumitTable(e) })

                                        }
                                    />
                                </Grid>
                            }
                            {sID != null &&
                                <Grid item gap={2}>
                                    <BtnDuplicate id={"btnDuplicate"} onClick={form.handleSubmit((e) => { onDuplicate(e, 1) })} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>


                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e, sMode, nDupYear),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

                <DialogPreview
                    IsOpen={isOpen}
                    IsBackdropClick={false}
                    onClose={() => { setisOpen(false); }}
                    JsxDialogAction
                    CloseSave={sID == null ? true : false}
                    onClick={() => { onSummitRemark(); }}
                    Close={true}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={''}
                >
                    <Grid container justifyContent={"center"} >
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='หมายเหตุ'
                                name={`sRemark`}
                                maxLength={500}
                                id={`sRemark`}
                                required={false}
                                disabled={!isPermission || sID != null}
                            />
                        </Grid>
                    </Grid>
                </DialogPreview >
            </FormProvider>
        </React.Fragment >
    );
}
export default EquipmentWithdrawForm;

export interface EquipmentWithdrawIItem {
    sID?: string;
    nOrder?: number;
    nEquipmentID?: number;
    nWithdrawID?: number;
    nWithdrawItemID?: number;
    nHolderID?: number;
    sHolderName?: number;
}

